import React from 'react';

function VisionToRealitySection() {
  const styles = {
    section: {
      position: 'relative', minHeight: 520, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', padding: '80px 48px',
      backgroundImage: 'url(/construction.jpg)', backgroundSize: 'cover',
      backgroundPosition: 'center'
    },
    overlay: {
      position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 0
    },
    content: { position: 'relative', zIndex: 1, textAlign: 'center', maxWidth: 900 },
    subheadingRow: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginBottom: 16 },
    subheading: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: '26px', lineHeight: '100%',
      letterSpacing: '-0.01em', textTransform: 'uppercase', color: '#FFFFFF'
    },
    accentDash: {
      width: 150, height: 0, borderTop: '2px solid #E73123', opacity: 1, flexShrink: 0
    },
    titleWrap: { marginBottom: 24 },
    titleRed: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '40px', lineHeight: '100%',
      letterSpacing: 0, textTransform: 'uppercase', color: '#E73123', display: 'inline'
    },
    titleWhite: {
      fontFamily: 'Lato', fontWeight: 700, fontSize: '40px', lineHeight: '100%',
      letterSpacing: 0, textTransform: 'uppercase', color: '#FFFFFF', display: 'inline'
    },
    description: {
      fontFamily: 'Lato', fontWeight: 400, fontSize: 16, lineHeight: '26px',
      letterSpacing: 0, color: '#FFFFFF', margin: '0 auto 32px auto', textAlign: 'center'
    },
    buttons: { display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' },
    btnOngoing: {
      width: 240, height: 60, background: 'transparent', color: '#FFFFFF', border: '2px solid #FFFFFF',
      fontFamily: 'Lato', fontWeight: 700, fontSize: '18px', lineHeight: '100%',
      letterSpacing: 0, textTransform: 'uppercase', cursor: 'pointer', opacity: 1,
      display: 'flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box',
      borderRadius: 4
    },
    btnCompleted: {
      width: 240, height: 60, background: '#E73123', color: '#FFFFFF', border: 'none',
      fontFamily: 'Lato', fontWeight: 700, fontSize: '18px', lineHeight: '100%',
      letterSpacing: 0, textTransform: 'uppercase', cursor: 'pointer', opacity: 1,
      display: 'flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box',
      borderRadius: 4
    }
  };

  return React.createElement('section', { style: styles.section },
    React.createElement('div', { style: styles.overlay }),
    React.createElement('div', { style: styles.content },
      React.createElement('div', { style: styles.subheadingRow },
        React.createElement('div', { style: styles.accentDash }),
        React.createElement('h2', { style: styles.subheading }, 'FROM VISION TO REALITY'),
        React.createElement('div', { style: styles.accentDash })
      ),
      React.createElement('div', { style: styles.titleWrap },
        React.createElement('span', { style: styles.titleRed }, 'OUR WORK '),
        React.createElement('span', { style: styles.titleWhite }, 'SPEAKS FOR ITSELF')
      ),
      React.createElement('p', { style: styles.description },
        'Explore our diverse portfolio of infrastructure projects that reflect our expertise, precision, and commitment to engineering excellence.'
      ),
      React.createElement('div', { style: styles.buttons },
        React.createElement('button', { style: styles.btnOngoing }, 'ONGOING PROJECTS'),
        React.createElement('button', { style: styles.btnCompleted }, 'COMPLETED PROJECTS')
      )
    )
  );
}

export default VisionToRealitySection;
